import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * GET a catalog endpoint, keyed on the full path so a filter change refetches.
 *
 * `notConfigured` is split out from `error` because a missing TMDB key is a
 * setup step with a specific fix, not a failure the user can retry past.
 */
const useCatalog = (path) => {
  const [state, setState] = useState({ loading: true, data: null, error: '', notConfigured: false });

  useEffect(() => {
    if (!path) return undefined;

    let cancelled = false;
    setState((previous) => ({ ...previous, loading: true, error: '' }));

    axios
      .get(path)
      .then(({ data }) => {
        if (!cancelled) setState({ loading: false, data: data.data, error: '', notConfigured: false });
      })
      .catch((err) => {
        if (cancelled) return;
        setState({
          loading: false,
          data: null,
          error: err.response?.data?.error || 'Failed to reach the catalog',
          notConfigured: err.response?.status === 503
        });
      });

    return () => {
      cancelled = true;
    };
  }, [path]);

  return state;
};

export default useCatalog;
